import { SVGProps, Ref, forwardRef } from 'react'
const SvgTimeClock = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.5 12a10.5 10.5 0 1 0 21 0 10.5 10.5 0 0 0-21 0v0ZM12 12V8.25M12 12l4.687 4.688"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTimeClock)
export default ForwardRef
